// extracted by mini-css-extract-plugin
export default {"document":"DocumentViewer_document__11+04","page":"DocumentViewer_page__hNysx"};